/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { platformServerTesting, ServerTestingModule } from './public_api';
//# sourceMappingURL=testing.js.map